import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import { autoRehydrate } from 'redux-persist';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import areas from '../reducers/areas';
import entities from '../reducers/entities';
import uiElements from '../reducers/uiElements';
import global from '../reducers/global';
import { callAPIMiddleware } from '../services/callAPIMiddleware';
import profileMiddleware from '../services/profileMiddleware';
import production from '../utils/helpers';

const composeEnhancers = production
  ? compose
  : // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const communityStore = history =>
  combineReducers({
    router: connectRouter(history),
    areas,
    entities,
    global,
    uiElements,
  });

const injectHistoryIntoStore = history => {
  const middlewares = [thunkMiddleware, routerMiddleware(history), callAPIMiddleware, profileMiddleware];
  return createStore(
    communityStore(history),
    undefined,
    composeEnhancers(applyMiddleware(...middlewares), autoRehydrate()),
  );
};

export default injectHistoryIntoStore;
